import React from "react";
import Page from "components/Page";
import { Props } from "./Projects";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Projects = lazyWithRetry(() => import("./Projects"));

export default (props: Props) => (
  <Page>
    <Projects {...props} />
  </Page>
);
